module.exports = __webpack_public_path__ + "assets/media/l-2.fbddb81f.svg";